module.exports = __webpack_public_path__ + "static/media/bg-image-27.ad6d861c.jpg";